import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'bt-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  @Output() toggleSidenav = new EventEmitter();

  constructor(private authService: AuthService) { }

  ngOnInit() {
  }


  toggleMenu() {
    this.toggleSidenav.emit();
  }

  get fullName() {
    const fName = localStorage.getItem('name');
    const lName = localStorage.getItem('family');
    return fName + ' ' + lName;
  }

  get imagePic() {
    const pic = localStorage.getItem('thumbPic');
    if (!pic) {
      return;
    }

    return pic;
  }

  onLogout() {
    this.authService.signOut();
  }
}
